import React from 'react';
import './FollowUs.scss';

const FollowUs = props => {
    const { section, loginStatus, dataLocale } = props;
    return (
        <div className="container-fluid">
            <div className="socialLK col-sm-12">
                <h5 className="text-center socialLK_followText">{dataLocale.FOLLOW_US}</h5>
                <div className="col-sm-4 col-sm-offset-4 text-center">
                    <div className="socialLK_followIcons">
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://www.facebook.com/Lenskartindia"
                            onClick={() => {
                                if (window.dtm.LenskartRewamp) window.dtm.LenskartRewamp.footer.click.followus(section, 'facebook', loginStatus);
                            }}
                        >
                            <i className="fa fa-facebook fa-lg" aria-hidden="true"></i>
                        </a>
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://in.pinterest.com/lenskartindia/"
                            onClick={() => {
                                if (window.dtm.LenskartRewamp) window.dtm.LenskartRewamp.footer.click.followus(section, 'pinterest', loginStatus);
                            }}
                        >
                            <i className="fa fa-pinterest fa-lg" aria-hidden="true"></i>
                        </a>
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://twitter.com/Lenskart_com"
                            onClick={() => {
                                if (window.dtm.LenskartRewamp) window.dtm.LenskartRewamp.footer.click.followus(section, 'twitter', loginStatus);
                            }}
                        >
                            <i className="fa fa-twitter fa-lg" aria-hidden="true"></i>
                        </a>
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://instagram.com/lenskart/"
                            onClick={() => {
                                if (window.dtm.LenskartRewamp) window.dtm.LenskartRewamp.footer.click.followus(section, 'instagram', loginStatus);
                            }}
                        >
                            <i className="fa fa-instagram fa-lg" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FollowUs;
